<div class="row">
  <div class="col-sm-12">
    <app-card [title]="'admin.collection.show.collection information'|translate">
      <app-classic-box #classicForm  [classicBox]="classicBox" [data]="lastValue" (changeForm)="enableButton($event)"></app-classic-box>
    </app-card>
  </div>
</div>

<div class="row">
  <div class="col-sm-6">
    <app-card [title]="'admin.collection.show.properties_information'|translate">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th></th>
            <th>{{'doctrine.property.name'|translate}}</th>
            <th>{{'doctrine.property.status'|translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let property of properties">
            <td class="checkbox">
              <label>
                <input type="checkbox" name="propertyItem" #propertyItem="ngModel" (change)="onToggle()"
                       [(ngModel)]="property.checked">
              </label>
            </td>
            <td>
              {{property.name}}
            </td>
            <td>
              {{(property.status)?getProperty().PROPERTY_AMOUNT:getProperty().PROPERTY_METERS}}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </app-card>
  </div>
  <div class="col-sm-6">
    <app-card [cardOptionBtnValue]="'edit'|translate" [cardOptionBtn]="false" [title]="'admin.collection.linked.fabrics'|translate">
      <div class="row">
        <div class="col-sm-6">
          <ngx-treeview *ngIf="items.length>0"
                        [config]="config"
                        [items]="items"
                        [itemTemplate]="itemTemplate"
                        (selectedChange)="onSelectedChange($event)"
          >
          </ngx-treeview>
        </div>
      </div>
    </app-card>
  </div>
</div>


    <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
      <div class="card-block pull-right">
        <button (click)="submitItem(false)" class="btn btn-link me-4" type="button">{{'global.cancel'|translate}}</button>
        <button [disabled]="!enableSave"  (click)="submitItem(true)" class="btn btn-primary ripple light" type="button">{{(isEdit ? 'global.save_changes' : 'global.add') | translate}}</button>
      </div>
    </div>




<ng-template #itemTemplate let-item="item" let-onCollapseExpand="onCollapseExpand" let-onCheckedChange="onCheckedChange">
  <div class="form-inline row-item">
    <i *ngIf="item.children" (click)="onCollapseExpand()" aria-hidden="true" class="fa" [class.fa-caret-right]="item.collapsed"
       [class.fa-caret-down]="!item.collapsed"></i>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" [(ngModel)]="item.checked" (ngModelChange)="onCheckedChange()" [disabled]="item.disabled"
             [indeterminate]="item.indeterminate" />
      <label class="form-check-label" (click)="item.checked = !item.checked; onCheckedChange()">
        {{item.text}}
      </label>
    </div>
  </div>
</ng-template>

